import { render } from "./SavesBar.vue?vue&type=template&id=2b1668c2&scoped=true"
import script from "./SavesBar.vue?vue&type=script&lang=ts"
export * from "./SavesBar.vue?vue&type=script&lang=ts"

import "./SavesBar.vue?vue&type=style&index=0&id=2b1668c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b1668c2"

export default script